// src/components/HangerBanner.js
import React from 'react';
import './HangerBanner.css'; // Reuse the same CSS

const HangerBanner = () => {
  return (
    <div className="service-banner text-white d-flex align-items-center">
      <div className="container text-center">
        <h2 className="display-4 fw-bold mt-5">EVENT DECORATION</h2>
      </div>
    </div>
  );
};

export default HangerBanner;
